import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StoreInfoBox from './StoreInfoBox';
import { getId } from '@common/utils/brandDiffsUtils';
const BAAActionMoncler = React.lazy(() => import('@moncler/components/appointments/BookAnAppointmentAction'));
const BAAActionStone = React.lazy(() => import('@stone/components/appointments/BookAnAppointmentAction'));
const StoreBoutiqueInformation = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const [storeFilter, setStoreFilter] = useState([]);
    useEffect(() => {
        api.bookAnAppointmentStores(props.store.countryCode.value, '', 552250000).then((data) => {
            let arr = [...storeFilter];
            arr = data.stores.map((e) => e.code);
            setStoreFilter(arr);
        });
    }, []);
    return (React.createElement("div", { className: "store__moreinfo__section" },
        React.createElement("h2", { className: "store__moreinfo__section__title" }, t('store.boutiqueinformation')),
        React.createElement(StoreInfoBox, { store: props.store, className: "store__moreinfo__section__address" }),
        ((_b = (_a = props === null || props === void 0 ? void 0 : props.store) === null || _a === void 0 ? void 0 : _a.storeServices) === null || _b === void 0 ? void 0 : _b.bookAnAppointment) && (React.createElement(React.Fragment, null, getId() === 'MO' ? (React.createElement(BAAActionMoncler, Object.assign({ disabled: !storeFilter.includes(props.store.ID), store: props.store }, props))) : (React.createElement(BAAActionStone, Object.assign({ disabled: !storeFilter.includes(props.store.ID), store: props.store }, props)))))));
};
export default StoreBoutiqueInformation;
